import React from 'react';
import { NavLink } from 'react-router-dom';
import './sidebars.css';

const DashboardLayout = ({ children }) => {
    return (
        <div className="dashboard-layout">
            <nav className="navbar navbar-expand-md">
                <div className="container d-flex justify-content-start">
                    <NavLink className="navbar-brand" to="/pre-screening">Plasma p-tau for Clinical Trials</NavLink>
                </div>
            </nav>

            <main className="d-flex flex-nowrap main">
                {/*<div className="d-flex flex-column flex-shrink-0 p-3 text-bg-dark sidebar">
                    <ul className="nav nav-pills flex-column mb-auto">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/">Home</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/pre-screening">
                                Pre-Screening
                            </NavLink>
                        </li>
                        <li>
                            <NavLink className="nav-link" to="/data-analysis">
                                Data Analysis
                            </NavLink>
                        </li>
                    </ul>
                </div>*/}
                <div className="container mt-5">
                    {children}
                </div>
            </main>

            <footer className="footer">
                {/*<div className="bg-light py-3 py-md-4 py-xl-8 border-top border-light-subtle">
                    <div className="container overflow-hidden">
                        <div className="row gy-3 gy-md-5 gy-xl-0 align-items-sm-center">
                            <div className="col-xs-12 col-sm-6 col-xl-3 order-0 order-xl-0">
                                <div className="footer-logo-wrapper text-center text-sm-start">
                                    <a href="https://pascoallab.org" target='_blank'>
                                        <img src="/logo.png" alt="BootstrapBrain Logo" height="57" />
                                    </a>
                                </div>
                            </div>

                            <div className="col-xs-12 col-xl-6 order-2 order-xl-1">
                                <ul className="nav justify-content-center links">
                                    <li className="nav-item">
                                        <a className="nav-link link-secondary px-2 px-md-3" href="#!">About</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link link-secondary px-2 px-md-3" href="#!">Contact</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link link-secondary px-2 px-md-3" href="#!">Terms</a>
                                    </li>
                                    <li className="nav-item">
                                        <a className="nav-link link-secondary px-2 px-md-3" href="#!">Privacy</a>
                                    </li>
                                </ul>
                            </div>

                            <div className="col-xs-12 col-sm-6 col-xl-3 order-1 order-xl-2">
                                <div className="social-media-wrapper">
                                    <ul className="list-unstyled m-0 p-0 d-flex justify-content-center justify-content-sm-end">
                                        <li className="mr-3">
                                            <a href="https://x.com/LabPascoal" target='_blank'>
                                                <i className="fa-brands fa-x-twitter"></i>
                                            </a>
                                        </li>
                                        <li className="mr-3">
                                            <a href="https://pubmed.ncbi.nlm.nih.gov/?term=Pascoal%20TA%5BAuthor%5D&sort=pubdate" target='_blank'>
                                                <i className="fa-solid fa-book"></i>
                                            </a>
                                        </li>
                                        <li className="mr-3">
                                            <a href="mailto:pascoal-lab@list.pitt.edu">
                                                <i className="fa-regular fa-envelope"></i>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>*/}

                <div className="py-3 py-md-3 border-top border-light-subtle">
                    <div className="container overflow-hidden">
                        <div className="row">
                            <div className="col">
                                <div className="footer-copyright-wrapper text-center">
                                    &copy; 2025. All Rights Reserved.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </footer>
        </div>
    );
};

export default DashboardLayout;
